import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Playlist } from '@raydiant/api-client-js';
import {
  selectIsContentSharingEnabled,
  selectIsEnterpriseUser,
} from '../../selectors/user';
import * as domainActions from '../../actions/domains';
import * as applicationActions from '../../actions/applications';
import PlaylistSelectorV1 from './PlaylistSelectorV1';
import { selectApplications } from '../../selectors/applications';
import { selectDomainForCurrentUser } from '../../selectors/v2/domains';
import PlaylistSelectorV2 from './PlaylistSelectorV2';

export interface PlaylistSelectorProps {
  assignButtonLabel?: string;
  selectedProfileId: string;
  selectedPlaylistId?: string | null;
  onSelectProfile: (profileId: string) => void;
  onSelectPlaylist?: (playlistId: string) => void;
  onSelectBatchPlaylist?: (playlist: Playlist) => void;
  onNewPlaylist?: () => void;
  onNewPresentation?: (applicationId: string) => void;
  sortOnly?: boolean;
  showOpenLibraryButton?: boolean;
  batch?: boolean;
  filter?: boolean;
}

const PlaylistSelector: FC<PlaylistSelectorProps> = ({
  assignButtonLabel,
  batch,
  selectedPlaylistId,
  filter = false,
  selectedProfileId,
  showOpenLibraryButton = true,
  sortOnly,
  onSelectBatchPlaylist,
  onSelectProfile,
  onSelectPlaylist,
  onNewPlaylist,
  onNewPresentation,
}) => {
  const dispatch = useDispatch();

  const applications = useSelector(selectApplications);
  const isContentSharingEnabled = useSelector(selectIsContentSharingEnabled);
  const isEnterpriseUser = useSelector(selectIsEnterpriseUser);
  const domain = useSelector(selectDomainForCurrentUser);

  // Fetch applications if we have not before.
  useEffect(() => {
    if (applications.length) return;
    dispatch(applicationActions.fetchApplications());
  }, [dispatch, applications]);

  // Fetch domain if enterprise user and we have not before.
  useEffect(() => {
    if (!isEnterpriseUser || domain) return;
    dispatch(domainActions.fetchDomain());
  }, [dispatch, domain, isEnterpriseUser]);

  return (
    <>
      {isContentSharingEnabled ? (
        <PlaylistSelectorV2
          batch={batch}
          selectedPlaylistId={selectedPlaylistId}
          onSelectPlaylist={onSelectPlaylist}
          onSelectBatchPlaylist={onSelectBatchPlaylist}
          onNewPlaylist={onNewPlaylist}
        />
      ) : (
        <PlaylistSelectorV1
          assignButtonLabel={assignButtonLabel}
          batch={batch}
          filter={filter}
          selectedProfileId={selectedProfileId}
          showOpenLibraryButton={showOpenLibraryButton}
          sortOnly={sortOnly}
          onSelectBatchPlaylist={onSelectBatchPlaylist}
          onSelectProfile={onSelectProfile}
          onSelectPlaylist={onSelectPlaylist}
          onNewPlaylist={onNewPlaylist}
          onNewPresentation={onNewPresentation}
        />
      )}
    </>
  );
};

export default PlaylistSelector;
